/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overviewdeltavsprevious3Inputs */

const en_overviewdeltavsprevious3 = /** @type {(inputs: Overviewdeltavsprevious3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs. previous period`)
};

const de_overviewdeltavsprevious3 = /** @type {(inputs: Overviewdeltavsprevious3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zum Vorzeitraum`)
};

/**
* | output |
* | --- |
* | "vs. previous period" |
*
* @param {Overviewdeltavsprevious3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewdeltavsprevious3 = /** @type {((inputs?: Overviewdeltavsprevious3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewdeltavsprevious3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewdeltavsprevious3(inputs)
	return de_overviewdeltavsprevious3(inputs)
});
export { overviewdeltavsprevious3 as "overviewDeltaVsPrevious" }